<div id="search-box">
    
    <form name="searchBoxForm" novalidate>
        
        <div class="form-group">
            
            <div class="input-group">
                
                <span class="input-group-btn" ng-show="searchBoxForm.searchField.$viewValue">
                    <a role="button" class="btn" href="javascript:void(0);" ng-click="ctrl.clearSearchBoxForm()"><i class="fa fa-times-circle"></i></a>
                </span>
                
                <input type="text" id="search-field" class="form-control" name="searchField" placeholder="Caut&#259; dup&#259; ora&#x219; sau adres&#259;..." ng-required="true" ng-model="searchField" ng-change="ctrl.clearSubmitErrors()">
                
                <span class="input-group-btn">
                    <button type="button" class="btn" ng-click="ctrl.simulateSearch()"><i class="fa fa-search"></i></button>
                </span>
                
                <span class="input-group-btn" ng-show="::ctrl.geolocationSupport">
                    <a role="button" class="btn" href="javascript:void(0);" ng-click="ctrl.geolocate()">
                        <span class="hidden-xs">&nbsp;localizeaz&#259;-m&#259;</span>
                        <span class="geolocate-icon-wrapper">
                            <i class="fa fa-crosshairs" ng-show="!ctrl.spinners.geolocation"></i>
                            <i class="fa fa-circle-o-notch fa-spin" ng-show="ctrl.spinners.geolocation"></i>
                        </span>
                    </a>
                </span>
            </div>

            <div class="ng-messages-wrapper has-error">
                <div ng-messages="searchBoxForm.searchField.$error" ng-show="searchBoxForm.$submitted || searchBoxForm.searchField.$dirty">
                    <p class="help-block center" ng-message="required">Te rug&#259;m s&#259; completezi un nume de ora&#x219; sau o adres&#259; pentru care vrei s&#259; efectuezi c&#259;utarea</p>
                    <p class="help-block center" ng-message="couldNotFindPlace">Ne pare r&#259;u, nu am gasit loca&#539;ia specificat&#259;</p>
                </div>
                <p class="help-block center" ng-show="ctrl.geolocationDenied">Set&#259;rile browserului pentru aceast&#259; pagin&#259; nu permit localizarea</p>
            </div>
        </div>
    </form>
</div>
